import input from './input'
import check from './check'
import reset from './reset'

const findPwd = {
  name: 'findPwd',
  path: 'findPwd',
  redirect: 'findPwd/input',
  component: resolve => require(['../../../pages/custom/find-pwd'], resolve),
  children: [
    input,
    check,
    reset
  ]
}

export default findPwd
